import { FaRegComment, FaRegHeart } from "react-icons/fa6"


const ImageFullData = ({ image }) => {

  return <div className="w-[80vw] h-[80vh]">

    <div className="flex justify-center w-full">
      <img loading="lazy" src={image.imageUrl} className="h-80 w-auto" />
    </div>
    <div className="px-2">
      <p>{new Date(image.timeStamp).toDateString()}</p>
      <p><a href={'https://www.instagram.com/' + image.username} target="_blank" className="text-blue-400 hover:text-blue-500">{image.username}</a></p>
      <p><a href={image.postUrl} target="_blank" className="text-blue-400 hover:text-blue-500">Post URL</a></p>
      <div className="flex justify-between">
        <p>{image.like_count && image.like_count > 0 ? <p className="flex"><FaRegHeart size={24} /> {image.like_count}</p> : null}</p>
        <p>{image.comment_count && image.comment_count > 0 ? <p className="flex "><FaRegComment size={24} /> {image.comment_count}</p> : null}</p>
      </div>
      <p><span className="font-bold">Description :</span>{image.caption || image.description}</p>
      <div><span className="font-bold">Hashtags: </span>{image.hashtags ? image.hashtags.map(hashtag => <span key={hashtag} className="text-blue-500">#{hashtag} </span>) : null}</div>
      <div><span></span></div>
    </div>

  </div>
}

export default ImageFullData
